export namespace IScreenPay {
  export const Action = 'CalcSaldo';

  export enum LocalStorageKeys {
    CarNumbers = 'payment-screen-car-numbers',
    LastCarNumber = 'payment-screen-last-car-number',
  }

  export interface IPayInfo {
    description: string;
    sum: number;
    hasNumber: boolean;
    phoneSecurity: string;
    freeExitFlag: boolean;
    fiscalQRCode: string;
    disablePayFlag: boolean;
    saldoInfo: string;
  }
}